export default __webpack_public_path__ + "static/media/002-twitter.4c14d4fe.svg";